import { makeStyles } from '@fluentui/react-components';

const useCreditCheckStyles = makeStyles({
    checkCreditButton: {
        width: '200px'
    },
    creditCheckStatusBox: {
        width: '40%',
        marginLeft: '0'
    },
    billingText: {
        marginTop: '0',
        fontStyle: 'italic'
    }
});

export default useCreditCheckStyles;
